import { TooltipLexique } from 'locales/types/components/tooltip';

export const tooltipLexique: TooltipLexique = {
    instagram_stories: 'Stories instagram',
    noResult: 'Aucun résultat',
};

export default tooltipLexique;
